import Vue from 'vue'
import Vuex from 'vuex'
import { saveUserInfo,wxLogin } from '@/api/map/index'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('userInfo') ? localStorage.getItem('token').toString() : '',
    userId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).userId : '',
    name: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).name : '',
    sex: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).sex : 0,
    idCard: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).idCard : '',
    phone: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).phone : '',
    frontUrl: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).frontUrl : '',
    reverseUrl: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).reverseUrl : '',
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID:(state,userId)=>{
      state.userId = userId
    },
    SET_NAME:(state,name)=>{
      state.name = name
    },
    SET_SEX:(state,sex)=>{
      state.sex = sex
    },
    SET_IDCARD:(state,idCard)=>{
      state.idCard = idCard
    },
    SET_PHONE:(state,phone)=>{
      state.phone = phone
    },
    SET_FRONTURL:(state,frontUrl)=>{
      state.frontUrl = frontUrl
    },
    SET_REVERSERUL:(state,reverseUrl)=>{
      state.reverseUrl = reverseUrl
    }
  },
  actions: {
    // 登录
    // Login({ commit }, obj) {
    //   console.log('$$$',obj)
    //   return new Promise((resolve, reject) => {
    //     wxLogin(obj).then(res => {
    //       setToken(res.data.data.token)
    //       commit('SET_TOKEN', res.data.data.token)
    //       commit('SET_NAME', res.data.data.name)
    //       commit('SET_SEX', res.data.data.sex)
    //       commit('SET_IDCARD', res.data.data.idCard)
    //       commit('SET_PHONE', res.data.data.phone)
    //       localStorage.setItem('token', res.data.data.token)
    //       console.log(this.state)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    doLogin({commit},userInfo) {
      console.log('$$$',userInfo)
      const { token, name,sex,idCard,phone} = userInfo;
      commit('SET_TOKEN', token);
      commit('SET_NAME', name);
      commit('SET_SEX', sex);
      commit('SET_IDCARD', idCard);
      commit('SET_PHONE', phone);
      // state.token = token;
      // state.name = name;
      // state.sex = sex;
      // state.idCard = idCard;
      // state.phone = phone;
      console.log(this.state)
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          location.reload();
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
  modules: {
  }
})
